var map = {
	"./adventure-entrance.mp4": 48698,
	"./dice-roll.mp4": 94239,
	"./dojo-enter-no-mc.mp4": 83732,
	"./dojo-enter.mp4": 75400,
	"./gem_fire.mp4": 53829,
	"./gem_love.mp4": 79306,
	"./gem_nature.mp4": 49045,
	"./gem_rock.mp4": 73038,
	"./intro.mp4": 38913,
	"./victory.mp4": 48552,
	"./water-amulet.mp4": 59263,
	"./wind-amulet.mp4": 10198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63066;